export const getValue = <U extends keyof T, T extends object>(key: U) => (
  obj: T
) => obj[key];
